import getScenarioStore from './getScenarioStore';
import { SearchScenarioId } from '../store/schema/SearchScenarioId';
import {
    PillSuggestion,
    SubstrateSearchSuggestionSegment,
    SuggestionKind,
} from 'owa-search-service';

export default function queryIncludesKQLSuggestion(scenarioId: SearchScenarioId): boolean {
    const store = getScenarioStore(scenarioId);
    const suggestionPills = store.suggestionPills;
    const suggestionSegments = store.suggestionSegments;

    // If there aren't any pills (or segments as pills) in the store, return false.
    if ((!suggestionPills || suggestionPills.size === 0) && suggestionSegments.size === 0) {
        return false;
    }

    // If there are any persona pills in the store, return true.
    const personaPills = [...suggestionPills.values()].filter(
        (pill: PillSuggestion) => pill.kind === SuggestionKind.People
    );
    if (personaPills.length > 0) {
        return true;
    }

    // If there are any person segments in the store, return true;
    const personaSegments = [...suggestionSegments.values()].filter(
        (segment: SubstrateSearchSuggestionSegment) => segment.Type === 'Person'
    );
    if (personaSegments.length > 0) {
        return true;
    }

    // If no conditions have been hit, then query doesn't include KQL.
    return false;
}
